import FindMyTrain from './FindMyTrain';

export default FindMyTrain;